import React from "react";
import { useFela } from "react-fela";

import { useTheme } from "@/hooks/useTheme";
import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";

import { Item } from "./Item";
import { IInspectorColumnedSection } from "./types";

type IProps = IInspectorColumnedSection;

export const InspectorColumnedSection: React.FC<IProps> = ({
  title,
  description,
  items,
}) => {
  const { bp, colors } = useTheme();
  const { css } = useFela();

  return (
    <Grid
      customStyle={{
        padding: "40px 20px",
        [bp.FROM_DESKTOP]: {
          padding: "80px 20px",
        },
      }}
      wrapperStyle={{ backgroundColor: colors.WHITE, overflow: "hidden" }}
    >
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        })}
      >
        <Heading
          as="h3"
          customStyle={{
            fontSize: 36,
            lineHeight: "48px",
            marginBottom: 18,
            letterSpacing: "-0.02rem",
            color: colors.DARK_GREY,
            fontWeight: 700,
            textAlign: "center",
            [bp.FROM_DESKTOP]: {
              maxWidth: 870,
              fontSize: 48,
              lineHeight: "60px",
              marginBottom: 24,
            },
          }}
        >
          {title}
        </Heading>
        <p
          className={css({
            textAlign: "center",
            fontSize: 16,
            marginBottom: 64,
            lineHeight: "24px",
            color: colors.GRAY,
            [bp.FROM_TABLET]: {
              maxWidth: 630,
              marginBottom: 80,
            },
          })}
        >
          {description}
        </p>

        <div
          className={css({
            display: "grid",
            gridTemplateColumns: "1fr",
            gap: "40px 0",
            [bp.FROM_TABLET]: {
              gridTemplateColumns: "1fr 1fr",
              gridAutoFlow: "dense",
              gap: "130px 30px",
            },
          })}
        >
          {items.map(
            ({
              title,
              description,
              images,
              imageBgStyle,
              rightSidedImage,
              button,
            }) => (
              <Item
                key={`inspector_columned_item_${title.replace(" ", "_")}`}
                title={title}
                description={description}
                images={images}
                imageBgStyle={imageBgStyle}
                rightSidedImage={rightSidedImage}
                button={button}
              />
            ),
          )}
        </div>
      </div>
    </Grid>
  );
};
